import React from 'react';
import {query} from 'api';
import PropTypes from 'prop-types';
import Academies from './academies';
import FormationsList from './formationsList';
import {
  Container,
  Title,
  BackLink,
  Image,
  MainTitle,
  FormationsCover,
  Mask,
  FormationsContent,
  MediumTitle,
  FormationsHr,
} from './styles';

const Formations = ({data}) => (
  <Container>
    <FormationsCover>
      <Image
        src={data.acf.header_mobile_image ? data.acf.header_mobile_image : data.acf.header_image}
        placeholderStyle={{position: 'absolute', top: 0, left: 0}}
      />
      <BackLink to="/" />
      <Title>{data.acf.header_titre}</Title>
      <MainTitle>{data.acf.header_sous_titre}</MainTitle>
      <MediumTitle
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: data.content.rendered,
        }}
      />
      <Mask />
    </FormationsCover>
    <FormationsContent>
      <Academies />
      <FormationsHr />
      <FormationsList />
    </FormationsContent>
  </Container>
);

Formations.propTypes = {
  data: PropTypes.object,
};

export default Formations |> query('getFormations');
